import { Container, Grid } from "@mui/material";
import NertzGrid from "./nertz/NertzGrid";

function Home() {
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <NertzGrid />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Home;
